/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useRef, useState } from "react";
import { MdKeyboardArrowRight } from "react-icons/md";
import { BiHomeAlt } from "react-icons/bi";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../AddEmployee/AddEmployee.css";
import Select from "react-select";
import { Apiurl, GetToken } from "../../../Utils/utils";
import axios from "axios";
import { toast } from "react-toastify";
import FloatingLabelInput from "../../../Components/floatingLabel/FloatingLabel";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import Loader from "../../../Components/loader/loader";

const AddEmployee = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const comingData = location?.state || null;
  const isUpdate = !!comingData?.Id || !!comingData;

  const [showPassword, setShowPassword] = useState(false);

  const [addEmloyee, setAddEmloyee] = useState({
    Name: "",
    LastName: "",
    Address: "",
    Email: "",
    Phone: "",
    EmergencyContact: "",
    Gender: "",
    MaritalStatus: "",
    DateOfBirth: "",
    DateOfJoining: "",
    DateOfLeaving: "",
    Department: "",
    Designation: "",
    TeamLead: "",
    UserRole: "",
    UploardImage: "",
    AdhaarCardFront: "",
    AdhaarCardBack: "",
    Password: "",
    ImageExtension: "",
    ImageName: "",
    AdhaarFrontExtension: "",
    AdhaarFrontName: "",
    AdhaarBackExtension: "",
    AdhaarBackName: "",
    Education: "",
    UrlLink: "",
    PreviewImage: "",
  });

  const [departmentData, setDepartmentData] = useState([]);
  const [teamLeadData, setTeamLeadData] = useState([]);
  const [DesignationData, setDesignationData] = useState([]);
  const [filterTeamValue, setFilterTeamValue] = useState([]);
  const [userRoleData, setUserRoleData] = useState([]);
  const currentDate = new Date().toISOString().split("T")[0];
  const [showSidebar, setShowSidebar] = useState(true);
  const fileInputRef = useRef(null);
  const adhaarFileInputRef = useRef(null);
  const [departmentId, setDepartmentId] = useState("");
  const [designationId, setDesignationId] = useState("");
  const [adhaarImageFiles, setAdhaarImageFiles] = useState([]);

  const [finalUserRole, setFinalUserRole] = useState();
  const [userRoleError, setUserRoleError] = useState();

  const [errorName, setErrorName] = useState(false);
  const [errorLastName, setErrorLastName] = useState(false);
  const [errorAddress, setErrorAddress] = useState(false);
  const [errorEmail, setErrorEmail] = useState(false);
  const [errorPhone, setErrorPhone] = useState(false);
  const [errorEmergencyContact, setErrorEmergencyContact] = useState(false);
  const [errorDateOfBirth, setErrorDateOfBirth] = useState(false);
  const [errorDateOfJoining, setErrorDateOfJoining] = useState(false);
  const [errorDateofLeaving, setErrorDateOfLeaving] = useState(false);
  const [errorGender, setErrorGender] = useState(false);
  const [errorMaritalStatus, setErrorMaritalStatus] = useState(false);
  const [uploadAdhaarError, setUploadAdhaarError] = useState(false);
  const [departmentError, setDepartmentError] = useState(false);
  const [designationDepartmentError, setDesignationDepartmentError] = useState(false);
  const [teamLeadDepartMentError, setTeamLeadDepartMentError] = useState(false);
  const [uploadImageError, setUploadImageError] = useState(false);
  const [errorPassword, setErrorPassword] = useState(false);

  const Gender = [
    { value: "Male", label: "Male", id: 0 },
    { value: "Female", label: "Female", id: 1 },
    { value: "Other", label: "Other", id: 2 },
  ];

  const MaritalStatusOptions = [
    { value: "Single", label: "Single", id: 0 },
    { value: "Married", label: "Married", id: 1 },
    { value: "Divorced", label: "Divorced", id: 2 },
    { value: "Widowed", label: "Widowed", id: 3 },
  ];

  const safeDate = (value) => {
    if (!value) return "";
    const formatted = moment(value).format("YYYY-MM-DD");
    return formatted === "Invalid date" ? "" : formatted;
  };

  const safeImagePath = (value) => {
    if (!value) return "";
    if (typeof value !== "string") return "";
    return value.trim();
  };

  const normalizeDepartment = (data) => {
    if (data?.Departments?.Id || data?.Departments?.Name) {
      return {
        value: data.Departments.Id || "",
        label: data.Departments.Name || "",
        Id: data.Departments.Id || "",
        Name: data.Departments.Name || "",
      };
    }

    if (data?.DepartmentId || data?.DepartmentName) {
      return {
        value: data.DepartmentId || "",
        label: data.DepartmentName || "",
        Id: data.DepartmentId || "",
        Name: data.DepartmentName || "",
      };
    }

    if (typeof data?.Department === "object" && data?.Department !== null) {
      return {
        value: data.Department.Id || data.Department.value || "",
        label: data.Department.Name || data.Department.label || "",
        Id: data.Department.Id || data.Department.value || "",
        Name: data.Department.Name || data.Department.label || "",
      };
    }

    return "";
  };

  const normalizeDesignation = (data) => {
    if (data?.Designations?.Id || data?.Designations?.DesignationName || data?.Designations?.Name) {
      return {
        ...data.Designations,
        value: data.Designations.Id || "",
        label: data.Designations.DesignationName || data.Designations.Name || "",
        Id: data.Designations.Id || "",
        DesignationName:
          data.Designations.DesignationName || data.Designations.Name || "",
      };
    }

    if (data?.DesignationId || data?.DesignationName) {
      return {
        Id: data.DesignationId || "",
        value: data.DesignationId || "",
        label: data.DesignationName || "",
        DesignationName: data.DesignationName || "",
      };
    }

    if (typeof data?.Designation === "object" && data?.Designation !== null) {
      return {
        ...data.Designation,
        Id: data.Designation.Id || data.Designation.value || "",
        value: data.Designation.Id || data.Designation.value || "",
        label:
          data.Designation.DesignationName ||
          data.Designation.Name ||
          data.Designation.label ||
          "",
        DesignationName:
          data.Designation.DesignationName ||
          data.Designation.Name ||
          data.Designation.label ||
          "",
      };
    }

    return "";
  };

  const normalizeRole = (data) => {
    if (data?.Positions?.Id || data?.Positions?.RoleName) {
      return data.Positions;
    }
    if (data?.UserRole?.Id || data?.UserRole?.RoleName) {
      return data.UserRole;
    }
    return "";
  };

  const selectedDepartmentValue = useMemo(() => {
    if (!addEmloyee?.Department) return null;

    if (addEmloyee?.Department?.value && addEmloyee?.Department?.label) {
      return addEmloyee.Department;
    }

    if (addEmloyee?.Department?.Id && addEmloyee?.Department?.Name) {
      return {
        value: addEmloyee.Department.Id,
        label: addEmloyee.Department.Name,
      };
    }

    return null;
  }, [addEmloyee?.Department]);

  const selectedRoleValue = useMemo(() => {
    if (!addEmloyee?.UserRole) return null;

    if (addEmloyee?.UserRole?.Id) return addEmloyee?.UserRole;

    if (comingData?.Position) {
      return userRoleData?.find((item) => item?.Id === comingData?.Position) || null;
    }

    return null;
  }, [addEmloyee?.UserRole, userRoleData, comingData]);

  const handleDepartmentChange = (selectedOption) => {
    setDepartmentId(selectedOption?.value || selectedOption?.Id || "");
    setDesignationId("");
    setAddEmloyee((prev) => ({
      ...prev,
      Department: selectedOption || "",
      Designation: "",
      TeamLead: "",
    }));
  };

  const handleDesignationData = (selectedOption) => {
    setDesignationId(selectedOption?.Id || selectedOption?.value || "");
    setAddEmloyee((prev) => ({
      ...prev,
      Designation: selectedOption || "",
      TeamLead: "",
    }));
  };

  const handleTeamLeadData = (e) => {
    setAddEmloyee((prev) => ({ ...prev, TeamLead: e || "" }));
  };

  const handleUserRole = (e) => {
    setFinalUserRole(e);
    setAddEmloyee((prev) => ({
      ...prev,
      UserRole: e,
      Department: "",
      Designation: "",
      TeamLead: "",
    }));
    setDepartmentId("");
    setDesignationId("");
    setDesignationData([]);
    setTeamLeadData([]);
  };

  useEffect(() => {
    if (teamLeadData?.length && comingData?.TeamLead) {
      const filter = teamLeadData.filter((i) => i?.UserId === comingData?.TeamLead);
      setFilterTeamValue(filter);
      setAddEmloyee((prev) => ({ ...prev, TeamLead: filter?.[0] || null }));
    }
  }, [teamLeadData, comingData]);

  const DateOfBirth = (e) => {
    const selectedDate = e.target.value;
    const today = new Date();
    const birthDate = new Date(selectedDate);
    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      age < 18 ||
      (age === 18 &&
        (monthDiff < 0 ||
          (monthDiff === 0 && today.getDate() < birthDate.getDate())))
    ) {
      toast.error("Employee age must be at least 18 years.");
      setAddEmloyee((prev) => ({ ...prev, DateOfBirth: "" }));
    } else {
      setAddEmloyee((prev) => ({ ...prev, DateOfBirth: selectedDate }));
      setErrorDateOfBirth("");
    }
  };

  const isImageFile = (file) => {
    if (!file) return false;
    if (file instanceof File) return file.type?.startsWith("image/");
    if (typeof file === "string") {
      return /\.(jpg|jpeg|png|webp)$/i.test(file);
    }
    return false;
  };

  const handleFileChange = (event, fileType = "image") => {
    if (fileType === "adhaar") {
      const files = Array.from(event.target.files || []);

      if (!files.length) {
        setAdhaarImageFiles([]);
        setUploadAdhaarError("useruploadAdhaar");
        return;
      }

      if (files.length > 2) {
        toast.error("Please upload only Aadhaar front and back.");
        event.target.value = "";
        setAdhaarImageFiles([]);
        setUploadAdhaarError("useruploadAdhaar");
        return;
      }

      const validFiles = files.filter((file) => {
        const allowedTypes = [
          "image/jpeg",
          "image/jpg",
          "image/png",
          "application/pdf",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ];

        if (!allowedTypes.includes(file.type)) {
          toast.error(`${file.name} is not a supported file.`);
          return false;
        }

        return true;
      });

      if (!validFiles.length) {
        event.target.value = "";
        setAdhaarImageFiles([]);
        setUploadAdhaarError("useruploadAdhaar");
        return;
      }

      setAdhaarImageFiles(validFiles);
      setUploadAdhaarError(validFiles.length < 2 ? "useruploadAdhaar" : "");
      return;
    }

    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64Image = reader.result;
      const fileExtension = file.name.split(".").pop().toLowerCase();

      setAddEmloyee((prev) => ({
        ...prev,
        UploardImage: file,
        ImageExtension: fileExtension,
        ImageName: file.name,
        PreviewImage: base64Image,
        UrlLink: "",
      }));
    };
    reader.readAsDataURL(file);
  };

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => setShowSidebar(false), 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  useEffect(() => {
    if (!comingData) return;

    const normalizedDepartment = normalizeDepartment(comingData);
    const normalizedDesignation = normalizeDesignation(comingData);
    const normalizedRole =
      userRoleData?.find((e) => e?.Id === comingData?.Position) ||
      normalizeRole(comingData) ||
      "";

    const comingGender = Gender?.find((i) => i?.id === comingData?.Gender) || "";
    const comingMaritalStatus =
      MaritalStatusOptions?.find((e) => e?.id === comingData?.MaritalStatus) || null;

    const profileUrl =
      safeImagePath(comingData?.UrlLink) ||
      safeImagePath(comingData?.Photo) ||
      safeImagePath(comingData?.ProfileImage) ||
      "";

    const adhaarFront =
      safeImagePath(comingData?.AadharCardFront) ||
      safeImagePath(comingData?.AdhaarCardFront) ||
      "";

    const adhaarBack =
      safeImagePath(comingData?.AadharCardBack) ||
      safeImagePath(comingData?.AdhaarCardBack) ||
      "";

    setAddEmloyee((prev) => ({
      ...prev,
      Name: comingData?.FirstName || comingData?.Name || "",
      LastName: comingData?.LastName || "",
      Email: comingData?.Email || "",
      Address: comingData?.Address || "",
      Phone: comingData?.Mobile || comingData?.Phone || "",
      EmergencyContact: comingData?.Emergencycontactno || comingData?.EmergencyContact || "",
      Gender: comingGender,
      DateOfBirth: safeDate(comingData?.DateOfBirth),
      DateOfJoining: safeDate(comingData?.DateofJoining || comingData?.DateOfJoining),
      DateOfLeaving: safeDate(comingData?.DateOfLeaving),
      Department: normalizedDepartment,
      Designation: normalizedDesignation,
      UserRole: normalizedRole,
      TeamLead: prev?.TeamLead || null,
      MaritalStatus: comingMaritalStatus,
      Education: comingData?.Education || "",
      UrlLink: profileUrl,
      UploardImage: profileUrl,
      AdhaarCardFront: adhaarFront,
      AdhaarCardBack: adhaarBack,
      PreviewImage: profileUrl,
      Password: "",
    }));

    setFinalUserRole(normalizedRole || "");
    setDepartmentId(normalizedDepartment?.Id || normalizedDepartment?.value || "");
    setDesignationId(normalizedDesignation?.Id || normalizedDesignation?.value || "");
  }, [comingData, userRoleData]);

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  function isValidEmail(Email) {
    return emailRegex.test(Email);
  }

  const validateAdd = () => {
    if (!addEmloyee?.Name?.trim()) {
      setErrorName("usernamedata");
      toast.error("First Name is required.");
      return false;
    }

    if (!addEmloyee?.Email) {
      setErrorEmail("userEmail");
      toast.error("Email is required.");
      return false;
    }

    if (!isValidEmail(addEmloyee?.Email)) {
      toast.error("Please enter a valid email.");
      return false;
    }

    if (!addEmloyee?.Password) {
      setErrorPassword("password");
      toast.error("Password is required.");
      return false;
    }

    if (!addEmloyee.UserRole) {
      setUserRoleError("userRole");
      toast.error("User Role is required.");
      return false;
    }

    if (!adhaarImageFiles || adhaarImageFiles.length < 2) {
      setUploadAdhaarError("useruploadAdhaar");
      toast.error("Please upload both Aadhaar front and back.");
      return false;
    }

    return true;
  };

  const validateUpdate = () => {
    if (!addEmloyee?.Name?.trim()) {
      setErrorName("usernamedata");
      toast.error("First Name is required.");
      return false;
    }

    if (!addEmloyee?.Email && !comingData?.Email) {
      setErrorEmail("userEmail");
      toast.error("Email is required.");
      return false;
    }

    if ((addEmloyee?.Email || comingData?.Email) && !isValidEmail(addEmloyee?.Email || comingData?.Email)) {
      toast.error("Please enter a valid email.");
      return false;
    }

    if (!addEmloyee?.DateOfBirth) {
      setErrorDateOfBirth("userDateOfBirth");
      toast.error("Date of Birth is required.");
      return false;
    }

    if (!addEmloyee?.DateOfJoining) {
      setErrorDateOfJoining("userDateOfJoining");
      toast.error("Date of Joining is required.");
      return false;
    }

    return true;
  };

  const handleAddEmployee = (e) => {
    e?.preventDefault();

    if (isUpdate) {
      if (!validateUpdate()) return;
    } else {
      if (!validateAdd()) return;
    }

    setLoading(true);
    const LoginToken = GetToken();
    const formData = new FormData();

    if (comingData?.Id) formData.append("Id", comingData?.Id);

    if (addEmloyee?.Name) formData.append("FirstName", addEmloyee?.Name);
    if (addEmloyee?.LastName) formData.append("LastName", addEmloyee?.LastName);
    if (addEmloyee?.Gender?.id !== undefined) formData.append("Gender", addEmloyee?.Gender?.id);
    if (addEmloyee?.Phone) formData.append("Mobile", addEmloyee?.Phone);

    const designationValue =
      addEmloyee?.Designation?.Id ||
      addEmloyee?.Designation?.value ||
      comingData?.Designations?.Id ||
      comingData?.DesignationId ||
      "";

    if (designationValue) formData.append("Designation", designationValue);

    const departmentValue =
      addEmloyee?.Department?.value ||
      addEmloyee?.Department?.Id ||
      comingData?.Departments?.Id ||
      comingData?.DepartmentId ||
      "";

    if (departmentValue) formData.append("Department", departmentValue);

    if (addEmloyee?.Address) formData.append("Address", addEmloyee?.Address);
    if (addEmloyee?.DateOfBirth) formData.append("DateOfBirth", addEmloyee?.DateOfBirth);
    if (addEmloyee?.Education) formData.append("Education", addEmloyee?.Education);

    const positionValue =
      addEmloyee?.UserRole?.Id ||
      comingData?.Position ||
      comingData?.Positions?.Id ||
      "";

    if (positionValue) formData.append("Position", positionValue);

    const teamLeadValue = addEmloyee?.TeamLead?.UserId || filterTeamValue?.[0]?.UserId || "";
    if (teamLeadValue) formData.append("TeamLead", teamLeadValue);

    if (addEmloyee?.DateOfJoining) formData.append("DateOfJoining", addEmloyee?.DateOfJoining);
    if (addEmloyee?.DateOfLeaving) formData.append("DateofLeaving", addEmloyee?.DateOfLeaving);
    if (addEmloyee?.EmergencyContact) {
      formData.append("Emergencycontactno", addEmloyee?.EmergencyContact);
    }

    if (addEmloyee?.MaritalStatus) {
      const maritalStatusValue = addEmloyee?.MaritalStatus?.id;
      if (maritalStatusValue !== undefined && maritalStatusValue !== null) {
        formData.append("MaritalStatus", maritalStatusValue);
      }
    }

    if (isUpdate) {
      if (addEmloyee?.AdhaarCardFront && typeof addEmloyee?.AdhaarCardFront === "string") {
        formData.append("AadharCardFront", addEmloyee?.AdhaarCardFront);
      }
      if (addEmloyee?.AdhaarCardBack && typeof addEmloyee?.AdhaarCardBack === "string") {
        formData.append("AadharCardBack", addEmloyee?.AdhaarCardBack);
      }
    }

    if (adhaarImageFiles?.length > 0) {
      adhaarImageFiles.forEach((file) => formData.append("AadharFiles", file));
    }

    if (addEmloyee?.UploardImage instanceof File) {
      formData.append("Photo", addEmloyee?.UploardImage);
      if (addEmloyee?.ImageExtension) {
        formData.append("PhotoExtenssion", addEmloyee?.ImageExtension);
      }
    } else if (typeof addEmloyee?.PreviewImage === "string" && addEmloyee?.PreviewImage.startsWith("data:")) {
      formData.append("Photo", addEmloyee?.PreviewImage);
      if (addEmloyee?.ImageExtension) {
        formData.append("PhotoExtenssion", addEmloyee?.ImageExtension);
      }
    } else if (addEmloyee?.UrlLink) {
      formData.append("UrlLink", addEmloyee?.UrlLink);
    } else if (isUpdate && comingData?.UrlLink) {
      formData.append("UrlLink", comingData?.UrlLink);
    }

    if (!isUpdate) {
      if (addEmloyee?.Email) formData.append("Email", addEmloyee?.Email);
      if (addEmloyee?.Password) formData.append("Password", addEmloyee?.Password);
    }

    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Admin/SaveEmployee`,
      data: formData,
    };

    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          toast.success(e?.data?.message || (isUpdate ? "Employee updated successfully" : "Employee added successfully"));

          setAddEmloyee({
            Name: "",
            LastName: "",
            Address: "",
            Email: "",
            Phone: "",
            EmergencyContact: "",
            Gender: "",
            DateOfBirth: "",
            DateOfJoining: "",
            DateOfLeaving: "",
            Department: "",
            Designation: "",
            TeamLead: "",
            UserRole: "",
            UploardImage: "",
            Password: "",
            ImageExtension: "",
            MaritalStatus: "",
            AdhaarCardFront: "",
            AdhaarCardBack: "",
            Education: "",
            UrlLink: "",
            PreviewImage: "",
          });

          setAdhaarImageFiles([]);
          setErrorName("");
          setErrorLastName("");
          setErrorEmail("");
          setErrorAddress("");
          setErrorPhone("");
          setErrorEmergencyContact("");
          setErrorPassword("");
          setErrorDateOfBirth("");
          setErrorDateOfJoining("");
          setErrorDateOfLeaving("");
          setErrorGender("");
          setUserRoleError("");
          setUploadImageError("");
          setDepartmentError("");
          setDesignationDepartmentError("");
          setTeamLeadDepartMentError("");
          setUploadAdhaarError("");

          if (fileInputRef.current) fileInputRef.current.value = null;
          if (adhaarFileInputRef.current) adhaarFileInputRef.current.value = null;

          navigate("/Adm/Employees/AllEmployees");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error("SaveEmployee Error:", err);
        toast.error(err?.response?.data?.message || "Something went wrong");
      });
  };

  const getDepartment = () => {
    setLoading(true);
    const token = GetToken();

    axios({
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      url: `${Apiurl()}/Admin/GetDepartments`,
    })
      .then((e) => {
        const data = JSON.parse(e?.data?.data || "[]");
        const finalData = data?.map((item) => ({
          label: item?.Name,
          value: item?.Id,
          Id: item?.Id,
          Name: item?.Name,
        }));
        setDepartmentData(finalData);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error("GetDepartments Error:", err);
      });
  };

  useEffect(() => {
    getDepartment();
  }, []);

  const handleDesignations = () => {
    const selectedDepartmentId =
      addEmloyee?.Department?.value || addEmloyee?.Department?.Id || departmentId;

    if (!selectedDepartmentId) return;

    setLoading(true);
    const LoginToken = GetToken();
    const data = { DepartmentId: selectedDepartmentId };

    axios({
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Admin/GetDesignations`,
      data: { data: JSON.stringify(data) },
    })
      .then((e) => {
        const data = JSON.parse(e?.data?.data || "[]");
        setDesignationData(data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error("GetDesignations Error:", err);
      });
  };

  useEffect(() => {
    if (departmentId) {
      handleDesignations();
    }
  }, [departmentId]);

  const GetTeamLeads = () => {
    const selectedDepartment =
      addEmloyee?.Department?.value || addEmloyee?.Department?.Id || "";
    const selectedDesignation =
      addEmloyee?.Designation?.Id || addEmloyee?.Designation?.value || "";

    if (!selectedDepartment || !selectedDesignation) return;

    setLoading(true);
    const LoginToken = GetToken();

    axios({
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Admin/GetTeamleads`,
      data: {
        data: JSON.stringify({
          Department: selectedDepartment,
          Designation: selectedDesignation,
        }),
      },
    })
      .then((e) => {
        const data = JSON.parse(e?.data?.data || "[]");
        setTeamLeadData(data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error("GetTeamleads Error:", err);
      });
  };

  useEffect(() => {
    if (addEmloyee?.Designation?.Id || addEmloyee?.Designation?.value) {
      GetTeamLeads();
    } else {
      setTeamLeadData([]);
    }
  }, [addEmloyee?.Designation, addEmloyee?.Department]);

  const GetUserRole = () => {
    setLoading(true);
    const LoginToken = GetToken();

    axios({
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Admin/GetPositions`,
    })
      .then((e) => {
        const data = JSON.parse(e?.data?.data || "[]");
        setUserRoleData(data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error("GetPositions Error:", err);
      });
  };

  useEffect(() => {
    GetUserRole();
  }, []);

  const handleEmptyInputData = () => {
    setAddEmloyee({
      Name: "",
      LastName: "",
      Address: "",
      Email: "",
      Phone: "",
      EmergencyContact: "",
      Gender: "",
      MaritalStatus: "",
      DateOfBirth: "",
      DateOfJoining: "",
      DateOfLeaving: "",
      Department: "",
      Designation: "",
      TeamLead: "",
      UserRole: "",
      UploardImage: "",
      AdhaarCardFront: "",
      AdhaarCardBack: "",
      Password: "",
      ImageExtension: "",
      ImageName: "",
      Education: "",
      UrlLink: "",
      PreviewImage: "",
    });

    setErrorName("");
    setErrorLastName("");
    setErrorEmail("");
    setErrorAddress("");
    setErrorPhone("");
    setErrorEmergencyContact("");
    setErrorPassword("");
    setErrorDateOfBirth("");
    setErrorDateOfJoining("");
    setErrorDateOfLeaving("");
    setErrorGender("");
    setErrorMaritalStatus("");
    setUserRoleError("");
    setUploadImageError("");
    setUploadAdhaarError("");
    setDepartmentError("");
    setDesignationDepartmentError("");
    setTeamLeadDepartMentError("");
    setDepartmentId("");
    setDesignationId("");
    setShowPassword(false);
    setAdhaarImageFiles([]);
    setFinalUserRole("");

    if (fileInputRef.current) fileInputRef.current.value = null;
    if (adhaarFileInputRef.current) adhaarFileInputRef.current.value = null;
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />
        <section className={showSidebar ? "addEmloyees-section" : "addEmloyees-section-new"}>
          <div className="addEmloyees-all-icons">
            <p className="DASHBOARD-MAIN-HEADING">
              {isUpdate ? "Update Employee" : "Add Employee"}
            </p>

            <div className="dashboiard-inner-header">
              <BiHomeAlt className="home-icon-header-inn" />
              <MdKeyboardArrowRight />
              <p>Employees</p>
              <MdKeyboardArrowRight />
              <p>{isUpdate ? "Update Employee" : "Add Employee"}</p>
            </div>
          </div>

          <div className="Addemployee-main-container">
            <div className="Addemployee-outter-container">
              <div className="AddEmployee-heading">
                <p>{isUpdate ? "Update Employee" : "Add Employee"}</p>
              </div>

              <div className="addemployee-note">
                ℹ️ <strong>Note:</strong> Please ensure the employee's name matches exactly
                as it appears on the attendance sheet.
              </div>

              <div className="Addemployee-inner-container">
                <div className="Addemployee-inner-box row">
                  <div className="addemployee-section-title col-12">Personal Information</div>

                  <div className="Addemployee-inputs col-md-4">
                    <FloatingLabelInput
                      label="First Name*"
                      value={addEmloyee?.Name}
                      onChange={(e) => {
                        setAddEmloyee((prev) => ({ ...prev, Name: e?.target?.value }));
                        if (e?.target?.value?.trim()) setErrorName("");
                      }}
                    />
                    {errorName === "usernamedata" && !addEmloyee?.Name?.trim() && (
                      <span className="contact_error-Addemployee">First Name is required.</span>
                    )}
                  </div>

                  <div className="Addemployee-inputs col-md-4">
                    <FloatingLabelInput
                      label="Last Name"
                      value={addEmloyee?.LastName}
                      onChange={(e) =>
                        setAddEmloyee((prev) => ({ ...prev, LastName: e?.target?.value }))
                      }
                    />
                  </div>

                  <div className="Addemployee-inputs col-md-4">
                    <FloatingLabelInput
                      label="Email*"
                      value={addEmloyee?.Email}
                      readOnly={isUpdate}
                      disabled={isUpdate}
                      onChange={(e) => {
                        if (!isUpdate) {
                          setAddEmloyee((prev) => ({ ...prev, Email: e?.target?.value }));
                          if (e?.target?.value?.trim()) setErrorEmail("");
                        }
                      }}
                    />
                    {errorEmail === "userEmail" && !addEmloyee?.Email && (
                      <span className="contact_error-Addemployee">Email is required.</span>
                    )}
                  </div>

                  {!isUpdate && (
                    <div className="Addemployee-inputs col-md-4">
                      <div className="password-field-wrapper-addemployee">
                        <FloatingLabelInput
                          type={showPassword ? "text" : "password"}
                          label="Password*"
                          value={addEmloyee?.Password}
                          onChange={(e) => {
                            setAddEmloyee((prev) => ({
                              ...prev,
                              Password: e?.target?.value,
                            }));
                            if (e?.target?.value?.trim()) setErrorPassword("");
                          }}
                        />
                        <button
                          type="button"
                          className="password-toggle-icon-addemployee"
                          onClick={() => setShowPassword((prev) => !prev)}
                        >
                          {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                      </div>

                      {errorPassword === "password" && !addEmloyee?.Password && (
                        <span className="contact_error-Addemployee">Password is required.</span>
                      )}
                    </div>
                  )}

                  <div className="Addemployee-inputs col-md-4">
                    <FloatingLabelInput
                      label="Address"
                      value={addEmloyee?.Address}
                      onChange={(e) =>
                        setAddEmloyee((prev) => ({ ...prev, Address: e?.target?.value }))
                      }
                    />
                  </div>

                  <div className="Addemployee-inputs col-md-4">
                    <FloatingLabelInput
                      label="Education"
                      value={addEmloyee?.Education}
                      onChange={(e) =>
                        setAddEmloyee((prev) => ({ ...prev, Education: e?.target?.value }))
                      }
                    />
                  </div>

                  <div className="Addemployee-inputs col-md-6">
                    <FloatingLabelInput
                      type="tel"
                      label="Phone No"
                      maxLength="10"
                      value={addEmloyee?.Phone}
                      onChange={(e) => {
                        const inputMobile = e.target.value.replace(/\D/g, "").slice(0, 10);
                        setAddEmloyee((prev) => ({ ...prev, Phone: inputMobile }));
                      }}
                    />
                  </div>

                  <div className="Addemployee-inputs col-md-6">
                    <FloatingLabelInput
                      type="tel"
                      maxLength="10"
                      label="Emergency Contact No."
                      value={addEmloyee?.EmergencyContact}
                      onChange={(e) => {
                        const inputMobile = e.target.value.replace(/\D/g, "").slice(0, 10);
                        setAddEmloyee((prev) => ({
                          ...prev,
                          EmergencyContact: inputMobile,
                        }));
                      }}
                    />
                  </div>

                  <div className="Addemployee-inputs-gender col-md-6">
                    <label className="label-manaegement-section">Gender</label>
                    <Select
                      classNamePrefix="genderSelect"
                      placeholder="Please Select Gender"
                      options={Gender}
                      value={addEmloyee?.Gender}
                      onChange={(selectedOption) =>
                        setAddEmloyee((prev) => ({ ...prev, Gender: selectedOption }))
                      }
                    />
                  </div>

                  <div className="Addemployee-inputs-gender col-md-6">
                    <label className="label-manaegement-section">Marital Status</label>
                    <Select
                      classNamePrefix="maritalStatusSelect"
                      placeholder="Please Select Marital Status"
                      options={MaritalStatusOptions}
                      value={addEmloyee?.MaritalStatus || ""}
                      onChange={(selectedOption) =>
                        setAddEmloyee((prev) => ({
                          ...prev,
                          MaritalStatus: selectedOption || null,
                        }))
                      }
                    />
                  </div>

                  <div className="addemployee-section-title col-12">Dates</div>

                  <div className="Addemployee-inputs-cal col-md-4">
                    <label htmlFor="DateOfBirth">Date of Birth{isUpdate ? "*" : ""}</label>
                    <input
                      type="date"
                      id="DateOfBirth"
                      value={addEmloyee?.DateOfBirth}
                      onChange={DateOfBirth}
                      max={moment().subtract(18, "years").format("YYYY-MM-DD")}
                    />
                    {errorDateOfBirth === "userDateOfBirth" && !addEmloyee?.DateOfBirth && (
                      <span className="contact_error-dob">Date Of Birth is required.</span>
                    )}
                  </div>

                  <div className="Addemployee-inputs-cal col-md-4">
                    <label>Date of Joining{isUpdate ? "*" : ""}</label>
                    <input
                      type="date"
                      value={addEmloyee?.DateOfJoining}
                      onChange={(e) =>
                        setAddEmloyee((prev) => ({
                          ...prev,
                          DateOfJoining: e?.target?.value,
                        }))
                      }
                      max={currentDate}
                    />
                    {errorDateOfJoining === "userDateOfJoining" &&
                      !addEmloyee?.DateOfJoining && (
                        <span className="contact_error-dob">Date Of Joining is required.</span>
                      )}
                  </div>

                  <div className="Addemployee-inputs-cal col-md-4">
                    <label>Date of Leaving</label>
                    <input
                      type="date"
                      value={addEmloyee?.DateOfLeaving}
                      onChange={(e) =>
                        setAddEmloyee((prev) => ({
                          ...prev,
                          DateOfLeaving: e?.target?.value,
                        }))
                      }
                      max={currentDate}
                    />
                  </div>

                  <div className="addemployee-section-title col-12">Role & Department</div>

                  <div className="Addemployee-inputs-gender col-md-4">
                    <label className="label-manaegement-section">
                      User Role{!isUpdate ? "*" : ""}
                    </label>
                    <Select
                      classNamePrefix="prefix-department"
                      placeholder="Please Select User Role"
                      options={userRoleData}
                      getOptionLabel={(options) => options?.RoleName}
                      getOptionValue={(options) => options?.Id}
                      onChange={handleUserRole}
                      value={selectedRoleValue}
                    />
                    {userRoleError === "userRole" && !finalUserRole && (
                      <span className="contact_error-Addemployee">User Role is required.</span>
                    )}
                  </div>

                  {addEmloyee?.UserRole?.RoleName !== "Admin" &&
                  (addEmloyee?.UserRole?.Id || comingData?.Position) ? (
                    <div className="Addemployee-inputs-department col-md-4">
                      <label className="label-manaegement-section">Department</label>
                      <Select
                        classNamePrefix="prefix-department"
                        placeholder="Please Select Department"
                        options={departmentData}
                        getOptionLabel={(options) => options?.label}
                        getOptionValue={(options) => options?.value}
                        value={selectedDepartmentValue}
                        onChange={handleDepartmentChange}
                      />
                    </div>
                  ) : null}

                  {addEmloyee?.UserRole?.RoleName !== "Admin" &&
                  addEmloyee?.Department &&
                  addEmloyee?.Department?.Name !== "Sales/Marketing" &&
                  addEmloyee?.Department?.label !== "Sales/Marketing" ? (
                    <div className="Addemployee-inputs-department-optional col-md-4">
                      <label className="label-manaegement-section">Designation</label>
                      <Select
                        classNamePrefix="subdepartment-dropdown"
                        placeholder="Please Select Designation"
                        options={DesignationData}
                        getOptionLabel={(options) => options?.DesignationName}
                        getOptionValue={(options) => options?.Id}
                        onChange={handleDesignationData}
                        value={addEmloyee?.Designation || null}
                      />
                    </div>
                  ) : null}

                  {((addEmloyee?.Designation &&
                    addEmloyee?.UserRole?.RoleName !== "TeamLead" &&
                    addEmloyee?.UserRole?.RoleName !== "HR") ||
                    addEmloyee?.Department?.Name === "Sales/Marketing" ||
                    addEmloyee?.Department?.label === "Sales/Marketing") && (
                    <div className="Addemployee-inputs-department-optional col-md-4">
                      <label className="label-manaegement-section">Team Lead</label>
                      <Select
                        classNamePrefix="subdepartment-dropdown"
                        placeholder="Please Select Team Lead"
                        options={teamLeadData}
                        getOptionLabel={(options) => options?.FirstName}
                        getOptionValue={(options) => options?.Id}
                        onChange={handleTeamLeadData}
                        value={addEmloyee?.TeamLead}
                      />
                    </div>
                  )}

                  <div className="addemployee-section-title col-12">Documents</div>

                  <div className="addemployee-file-group col-md-6">
                    <label className="upload-image-add-employee">Profile Image</label>
                    <div className="Addemployee-input-file">
                      <input
                        className="Addemployee-file-input"
                        id="fileInput"
                        type="file"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        accept=".jpg,.jpeg,.png"
                      />
                    </div>

                    {(addEmloyee?.PreviewImage || addEmloyee?.UrlLink) &&
                    isImageFile(addEmloyee?.PreviewImage || addEmloyee?.UrlLink) ? (
                      <div className="profile-preview-wrap">
                        <img
                          src={addEmloyee?.PreviewImage || addEmloyee?.UrlLink}
                          alt="Profile Preview"
                          className="profile-preview-image"
                        />
                      </div>
                    ) : null}
                  </div>

                  <div className="addemployee-file-group col-md-6">
                    <label className="upload-image-add-employee">
                      Aadhaar Files (Front & Back){!isUpdate ? "*" : ""}
                    </label>
                    <div className="Addemployee-input-file">
                      <input
                        className="Addemployee-file-input"
                        id="adhaarInput"
                        type="file"
                        ref={adhaarFileInputRef}
                        onChange={(e) => handleFileChange(e, "adhaar")}
                        multiple
                        accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                      />
                    </div>

                    {adhaarImageFiles?.length > 0 ? (
                      <div className="selected-aadhaar-files">
                        {adhaarImageFiles.map((file, index) => (
                          <div className="selected-aadhaar-file-item" key={index}>
                            {isImageFile(file) ? (
                              <div className="aadhaar-preview-card">
                                <img
                                  src={URL.createObjectURL(file)}
                                  alt={file.name}
                                  className="aadhaar-preview-image"
                                />
                                <span className="aadhaar-file-name">{file.name}</span>
                              </div>
                            ) : (
                              <div className="aadhaar-preview-card aadhaar-preview-doc">
                                <span className="aadhaar-file-name">{file.name}</span>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    ) : isUpdate && (addEmloyee?.AdhaarCardFront || addEmloyee?.AdhaarCardBack) ? (
                      <div className="selected-aadhaar-files">
                        {addEmloyee?.AdhaarCardFront ? (
                          <div className="selected-aadhaar-file-item">
                            <div className="aadhaar-preview-card">
                              {isImageFile(addEmloyee?.AdhaarCardFront) ? (
                                <img
                                  src={addEmloyee?.AdhaarCardFront}
                                  alt="Aadhaar Front"
                                  className="aadhaar-preview-image"
                                />
                              ) : (
                                <div className="aadhaar-preview-doc">
                                  <span className="aadhaar-file-name">Aadhaar Front</span>
                                </div>
                              )}
                            </div>
                          </div>
                        ) : null}

                        {addEmloyee?.AdhaarCardBack ? (
                          <div className="selected-aadhaar-file-item">
                            <div className="aadhaar-preview-card">
                              {isImageFile(addEmloyee?.AdhaarCardBack) ? (
                                <img
                                  src={addEmloyee?.AdhaarCardBack}
                                  alt="Aadhaar Back"
                                  className="aadhaar-preview-image"
                                />
                              ) : (
                                <div className="aadhaar-preview-doc">
                                  <span className="aadhaar-file-name">Aadhaar Back</span>
                                </div>
                              )}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    ) : null}

                    {!isUpdate &&
                    (uploadAdhaarError === "useruploadAdhaar" ||
                      !adhaarImageFiles ||
                      adhaarImageFiles.length < 2) ? (
                      <span className="contact_error-dob">
                        Please upload both Aadhaar front and back.
                      </span>
                    ) : adhaarImageFiles?.length > 0 ? (
                      <span className="contact_success-doc">
                        ✓ {adhaarImageFiles.length} file(s) selected
                      </span>
                    ) : null}
                  </div>

                  <div className="Addemployee-buttons col-12">
                    <button
                      className="Addemployee-submit-button"
                      onClick={handleAddEmployee}
                    >
                      {isUpdate ? "Update" : "Submit"}
                    </button>

                    <button
                      type="button"
                      onClick={handleEmptyInputData}
                      className="Addemployee-Cancel-button"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AddEmployee;